import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard, canMatch, loginGuard, loginCanMatch } from './core/guards/auth.guard';
import { EmailParamsResolver } from './modules/email-action/email-params.resolver';
import { homeResolver } from './core/resolvers/home.resolver';


const routes: Routes = [
  {
    path: 'metrics',
    canActivate: [authGuard],
    canMatch: [canMatch],
    data: { allowedGroups: ['TEACHER', 'STUDENT', 'ADMINISTRATOR', 'EVALUATOR', 'MANAGER'], showSidebar: true, showHeader: true },
    loadChildren: () => import('./modules/metrics/metrics.module').then(m => m.MetricsModule),
    title: 'Métricas'
  },
  {
    path: 'profile',
    canActivate: [authGuard],
    canMatch: [canMatch],
    data: { allowedGroups: ['ADMINISTRATOR', 'MANAGER', 'EVALUATOR', 'TEACHER', 'STUDENT'], showSidebar: false, showHeader: true },
    loadChildren: () => import('./modules/profile/profile.module').then(m => m.ProfileModule),
    title: 'Mi perfil'
  },
  {
    path: 'email-action',
    resolve: [EmailParamsResolver],
    loadChildren: () => import('./modules/email-action/email-action.module').then(m => m.EmailActionModule),
  },
  {
    path: '',
    canMatch: [loginCanMatch],
    data: { showSidebar: false, showHeader: false },
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'users',
    canActivate: [authGuard],
    canMatch: [canMatch],
    data: { allowedGroups: ['ADMINISTRATOR', 'MANAGER'], showSidebar: true, showHeader: true },
    loadChildren: () => import('./modules/users/users.module').then(m => m.UsersModule)
  },
  {
    path: 'moodle-error',
    data: { showSidebar: false, showHeader: false },
    loadComponent: () => import('./shared/pages/moodle-error-page/moodle-error-page.component').then(m => m.MoodleErrorPageComponent)
  },
  {
    path: 'not-invited',
    data: { showSidebar: false, showHeader: false },
    loadComponent: () => import('./shared/pages/not-invited-page/not-invited-page.component').then(m => m.NotInvitedPageComponent)
  },
  {
    path: '',
    canActivate: [authGuard],
    canMatch: [canMatch],
    data: { allowedGroups: ['STUDENT'], showSidebar: false, showHeader: true },
    loadChildren: () => import('./modules/student/student.module').then(m => m.StudentModule)
  },
  {
    path: '',
    canActivate: [authGuard],
    canMatch: [canMatch],
    data: { allowedGroups: ['TEACHER'], showSidebar: true, showHeader: true },
    loadChildren: () => import('./modules/teacher/teacher.module').then(m => m.TeacherModule),
    title: 'Mis cursos'
  },
  {
    path: '',
    canActivate: [authGuard],
    canMatch: [canMatch],
    data: { allowedGroups: ['SUPER'], showSidebar: true, showHeader: true },
    loadChildren: () => import('./modules/super/super.module').then(m => m.SuperModule)
  },
  {
    path: '',
    canActivate: [authGuard],
    resolve: { destination: homeResolver },
  },
  {
    path: '',
    canActivate: [authGuard],
    canMatch: [canMatch],
    data: { allowedGroups: ['ADMINISTRATOR', 'MANAGER'], showSidebar: true, showHeader: true },
    loadChildren: () => import('./modules/lessons/lessons.module').then(m => m.LessonsModule)
  },
  // {
  //   path: 'company',
  //   canActivate: [authGuard],
  //   canMatch: [canMatch],
  //   data: { allowedGroups: ['ADMIN'], showSidebar: true, showHeader: true },
  //   loadChildren: () => import('./modules/companies/companies.module').then(m => m.CompaniesModule)
  // },
  { path: '**', redirectTo: '/' }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
